<template>
  <div class="hidden" />
</template>
<script>
import {mapMutations, mapState} from 'vuex';
export default {
  name: 'ProductReviewsHeader',
  computed: {
    ...mapState('powerReviews', ['isLoadingScript', 'isWindowPwrLoaded']),
  },
  created() {
    if (!this.isWindowPwrLoaded && !this.isLoadingScript) {
      this.setIsLoadingScript(true);
      const script = document.createElement('script');
      script.setAttribute('src', '//ui.powerreviews.com/stable/4.1/ui.js');
      script.setAttribute('async', '');
      script.onload = () => {
        window.pwr =
          window.pwr ||
          function () {
            // eslint-disable-next-line no-undef
            (pwr.q = pwr.q || []).push(arguments);
          };
        this.setIsWindowPwrLoaded(true);
        this.setIsLoadingScript(false);
      };
      document.head.appendChild(script);
    }
  },
  methods: {
    ...mapMutations('powerReviews', ['setIsWindowPwrLoaded', 'setIsLoadingScript']),
  },
};
</script>
